export default {
  'dialog.cancel': 'Annuler',
  'dialog.close': 'Fermer',

  // Confirmation dialog
  'confirmation-dialog.title': 'Êtes-vous sûr?',
  'confirmation-dialog.confirm': 'Confirmer',
};
